import { Close, FilterSharp, GTranslate } from '@mui/icons-material';
import { Button, Card, CardHeader, CardActions, CardContent, Checkbox, FormControlLabel, IconButton, Modal, TextField, Typography, Tooltip, InputLabel, MenuItem, Select, FormControl, FormHelperText, SelectChangeEvent } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import SelectSingle from './SelectSingle';
import CnpjInput from './CnpjInput';
import object_nature from '../constants/natureza_objeto.json';
import body_name from '../constants/nome_orgao.json';
import body_type from '../constants/tipo_orgao.json';
import procurement_type from '../constants/tipo_licitacao.json';
import bidder_type from '../constants/tipo_vencedor.json';
import modality from '../constants/modalidade.json';
import cities from '../constants/cities.json';
import BidderNameInput from './BidderNameInput';
import HelpIcon from '@mui/icons-material/Help';
import mesoregioes from "../constants/mesorregioes.json";
import microregioes from "../constants/microrregioes.json";
import comarcas from "../constants/comarcas.json";
import regioes_administrativas from "../constants/regioes_administrativas.json";
import { comarcasSelect, mesoregioesSelect, microregioesSelect, regionsSelect } from '../constants/selects';
import navbar_background from '../assets/navbar_background.svg';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import NumberFormat from "react-number-format";
import SelectMultiple from './SelectMultiple';


type Props = {
    open: boolean,
    onClose: (() => void)
}

const groupsType = [
    { label: "Nenhum", value: " " },
    { label: "Mesoregião", value: "mesoregiao" },
    { label: "Microregião", value: "microregiao" },
    { label: "Comarca", value: "comarca" },
    { label: "Regiões Administrativas", value: "regioes administrativas" },
];
interface selectInterface {
    label: string,
    value: string,
}


interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}



function AdvancedFilterOverprice({ open, onClose }: Props) {

    const { filtersOverprice, setFiltersOverprice, cleanFiltersOverprice } = useContext(GlobalStateContext);
    const { typedFiltersOverprice, setTypedFiltersOverprice } = useContext(GlobalStateContext);
    const [groupType, setGroupType] = useState<string>(" ");
    const [group, setGroup] = useState<selectInterface[]>([]);
    const [selectGroup, setSelectedGroup] = useState<string>("");
    const [entities, setEntities] = useState<string[]>([]);
    const [regions, setRegions] = useState<string[]>([]);
    const [disableGroup, setDisableGroup] = useState(true);
    const [disableEntity, setDisableEntity] = useState(true);
    const [allSelected, setAllSelected] = useState(false);
    const { selectAll, setSelectAll } = useContext(GlobalStateContext)
    const [selectAllInitially, setSelectAllInitially] = useState(false)


    const handleSend = () => {
        if (typeof typedFiltersOverprice.min_amount !== 'undefined') {
            typedFiltersOverprice.min_amount = parseFloat(typedFiltersOverprice.min_amount.toString().replace(",", "."));
        }
        if (typeof typedFiltersOverprice.max_amount !== 'undefined') {
            typedFiltersOverprice.max_amount = parseFloat(typedFiltersOverprice.max_amount.toString().replace(",", "."));
        }
        if (typeof typedFiltersOverprice.min_cp_price !== 'undefined') {
            typedFiltersOverprice.min_cp_price = parseFloat(typedFiltersOverprice.min_cp_price.toString().replace(",", "."));
        }
        if (typeof typedFiltersOverprice.max_cp_price !== 'undefined') {
            typedFiltersOverprice.max_cp_price = parseFloat(typedFiltersOverprice.max_cp_price.toString().replace(",", "."));
        }
        if (typeof typedFiltersOverprice.min_rf_price !== 'undefined') {
            typedFiltersOverprice.min_rf_price = parseFloat(typedFiltersOverprice.min_rf_price.toString().replace(",", "."));
        }
        if (typeof typedFiltersOverprice.max_rf_price !== 'undefined') {
            typedFiltersOverprice.max_rf_price = parseFloat(typedFiltersOverprice.max_rf_price.toString().replace(",", "."));
        }
        if (typeof typedFiltersOverprice.min_diff_price !== 'undefined') {
            typedFiltersOverprice.min_diff_price = parseFloat(typedFiltersOverprice.min_diff_price.toString().replace(",", "."));
        }
        if (typeof typedFiltersOverprice.max_diff_price !== 'undefined') {
            typedFiltersOverprice.max_diff_price = parseFloat(typedFiltersOverprice.max_diff_price.toString().replace(",", "."));
        }
      


        setFiltersOverprice(typedFiltersOverprice);
        onClose();
    }

    const changeCheck = () => {
        setTypedFiltersOverprice({ ...typedFiltersOverprice, ...{ skip_duplicates: !typedFiltersOverprice.skip_duplicates } });
    }


    const originPurchaseOptions = [
        { label: "Contratos", value: "CONTRATOS" },
        { label: "Empenho", value: "EMPENHO" },
        { label: "Nota Fiscal", value: "NOTA FISCAL" },
        { label: "Licitações", value: "LICITAÇÕES" }
    ];

    const originReferenceOptions = [
        { label: "ANP", value: "ANP" },
        { label: "ANVISA", value: "ANVISA" },
        { label: "Consulta Remédios", value: "CONSULTA REMÉDIOS" },
        { label: "CEASAMINAS", value: "CEASAMINAS" }
    ];



    const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        if (ev.target.value == "") {
            setTypedFiltersOverprice({ ...typedFiltersOverprice, ...{ [ev.target.name]: undefined } });
        } else {
            setTypedFiltersOverprice({ ...typedFiltersOverprice, ...{ [ev.target.name]: ev.target.value } });
            console.log( ev.target.value);
        }

    }

    useEffect(() => {
        setSelectAll(false);
        (async () => {

            setSelectedGroup("");
            if (groupType === " ") {
                let aux: string[] = [];
                cities[0].children.forEach(city => {
                    aux.push(city.label);
                });
                setEntities(aux);
                setDisableGroup(true);
                setDisableEntity(false);
            } else if (groupType === "mesoregiao") {
                setGroup(mesoregioesSelect);
                setDisableGroup(false);
                setDisableEntity(true);
            } else if (groupType === "microregiao") {
                setGroup(microregioesSelect);
                setDisableGroup(false);
                setDisableEntity(true);
            } else if (groupType == "comarca") {
                setGroup(comarcasSelect);
                setDisableGroup(false);
                setDisableEntity(true);
            } else if (groupType == "") {
                setDisableEntity(true);
            } else {
                setGroup(regionsSelect);
                setDisableGroup(false);
                setDisableEntity(true);
            }
        })();

    }, [groupType]);

    useEffect(() => {
        setTypedFiltersOverprice({
            ...typedFiltersOverprice,
            'city': [],
        });
        setSelectAll(false);
        if (selectGroup != "") {
            if (groupType === "mesoregiao") {
                let aux = JSON.parse(JSON.stringify(mesoregioes));
                setEntities(aux[selectGroup].nome_cidade);
                setTypedFiltersOverprice({
                    ...typedFiltersOverprice,
                    'city': aux[selectGroup].nome_cidade,
                });
                setSelectAll(true);
                setDisableEntity(false);
            } else if (groupType === "microregiao") {
                let aux = JSON.parse(JSON.stringify(microregioes));
                setEntities(aux[selectGroup].nome_cidade);
                setTypedFiltersOverprice({
                    ...typedFiltersOverprice,
                    'city': aux[selectGroup].nome_cidade,
                });
                setSelectAll(true);
                setDisableEntity(false);
            } else if (groupType == "comarca") {
                let aux = JSON.parse(JSON.stringify(comarcas));
                setEntities(aux[selectGroup].nome_cidade);
                setTypedFiltersOverprice({
                    ...typedFiltersOverprice,
                    'city': aux[selectGroup].nome_cidade,
                });
                setSelectAll(true);
                setDisableEntity(false);
            } else {
                let aux = JSON.parse(JSON.stringify(regioes_administrativas));
                setEntities(aux[selectGroup].nome_cidade);
                setTypedFiltersOverprice({
                    ...typedFiltersOverprice,
                    'city': aux[selectGroup].nome_cidade,
                });
                setSelectAll(true);
                setDisableEntity(false);
            }


        }
    }, [selectGroup]);

    useEffect(() => {
        setTypedFiltersOverprice(filtersOverprice)
    }, [open])

    const handleChangeGroupType = (event: SelectChangeEvent) => {
        setGroupType(event.target.value);
    }

    const handleChangeSelectedGroup = (event: SelectChangeEvent) => {
        setSelectedGroup(event.target.value);
    }



    return (<Modal open={open} onClose={() => onClose()}>
        <div className="w-full h-full flex items-center justify-center">
            <Card className='w-full max-w-3xl relative'>
                <CardHeader
                    title="Filtros Avançados"
                    sx={{ color: 'white', bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}
                    titleTypographyProps={{ variant: 'h4' }}
                    action={
                        <IconButton onClick={(ev) => onClose()}>
                            <Close sx={{ color: 'white' }} />
                        </IconButton>
                    }>
                </CardHeader>
                <div className="h-[80vh] overflow-auto">
                    <CardContent>
                        <div className="mb-8">
                            <Typography variant='h5'>Faixa</Typography>

                            <div className="my-4">
                                <Typography variant='subtitle2'>Quantidade Comprada</Typography>
                                <div className="flex gap-4 my-2">
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name="min_amount" value={typedFiltersOverprice.min_amount} onChange={handleChange} customInput={TextField} className='w-full' label="Min." variant="outlined" /></div>
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name="max_amount" value={typedFiltersOverprice.max_amount} onChange={handleChange} customInput={TextField} className='w-full' label="Max." variant="outlined" /></div>
                                </div>
                            </div>

                            <div className="my-4">
                                <Typography variant='subtitle2'>Preço Compra Pública</Typography>
                                <div className="flex gap-4 my-2">
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name='min_cp_price' value={typedFiltersOverprice.min_cp_price} onChange={handleChange} customInput={TextField} className='w-full' label="Min." variant="outlined" /></div>
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name='max_cp_price' value={typedFiltersOverprice.max_cp_price} onChange={handleChange} customInput={TextField} className='w-full' label="Max." variant="outlined" /></div>
                                </div>
                            </div>

                            <div className="my-4">
                                <Typography variant='subtitle2'>Preço Referência</Typography>
                                <div className="flex gap-4 my-2">
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name='min_rf_price' value={typedFiltersOverprice.min_rf_price} onChange={handleChange} customInput={TextField} className='w-full' label="Min." variant="outlined" /></div>
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name='max_rf_price' value={typedFiltersOverprice.max_rf_price} onChange={handleChange} customInput={TextField} className='w-full' label="Max." variant="outlined" /></div>
                                </div>
                            </div>

                            <div className="my-4">
                                <Typography variant='subtitle2'>Diferença no preço</Typography>
                                <div className="flex gap-4 my-2">
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name='min_diff_price' value={typedFiltersOverprice.min_diff_price} onChange={handleChange} customInput={TextField} className='w-full' label="Min." variant="outlined" /></div>
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name='max_diff_price' value={typedFiltersOverprice.max_diff_price} onChange={handleChange} customInput={TextField} className='w-full' label="Max." variant="outlined" /></div>
                                </div>
                            </div>

                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Órgão</Typography>
                            <div className="flex gap-4 my-2">
                                <div className='flex-1'>
                                    <SelectSingle filterKey='body' label='Nome do Órgão' options={body_name.children} searchable overprice/>
                                </div>
                                <div className='flex-1'>
                                    <SelectSingle filterKey='body_type' label='Tipo de Órgão' options={body_type.children} overprice/>
                                </div>
                            </div>
                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Fornecedor</Typography>
                            <div className="flex gap-4 my-2">
                                <div className='w-1/4'>
                                    <SelectSingle filterKey='bidder_type' label='Tipo' options={bidder_type.children} overprice/>
                                </div>
                                <div className='flex-1'>
                                    <BidderNameInput />
                                </div>
                                {filtersOverprice.bidder_type === 'J' ?
                                    <div className='w-1/4'>
                                        <CnpjInput />
                                    </div>
                                    : null
                                }
                            </div>
                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Licitação</Typography>
                            <div className="flex gap-4 my-2">
                                <div className='w-2/4'>
                                    <SelectSingle filterKey='procurement_type' label='Tipo de Licitação' options={procurement_type.children} overprice/>
                                </div>
                                <div className='flex-1'>
                                    <SelectSingle filterKey='modality' label='Modalidade' options={modality.children} overprice />
                                </div>

                            </div>
                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Região</Typography>
                            <div className='my-4'>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="groupType">Tipo do Gupo</InputLabel>
                                    <Select
                                        labelId="groupType"
                                        id="groupType"
                                        value={groupType}
                                        label="Tipo do Grupo"
                                        displayEmpty={true}
                                        onChange={handleChangeGroupType}
                                    >
                                        {groupsType.map(({ label, value }) => (
                                            <MenuItem key={value} value={value}>{label}</MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </div>
                            <div className="my-4">
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="group">Grupo</InputLabel>
                                    <Select
                                        labelId="group"
                                        id="group"
                                        value={selectGroup}
                                        label="Grupo"
                                        onChange={handleChangeSelectedGroup}
                                        disabled={disableGroup}
                                    >

                                        {group.map(({ label, value }) => (
                                            <MenuItem key={value} value={value}>{label}</MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </div>
                            <div className="my-4">
                                <FormControl sx={{ width: '100%' }}>
                                    <SelectMultiple searchable disabled={disableEntity} filterKey='city' label='Entidade' options={entities.map(opt => opt)} closeButton overprice/>
                                </FormControl>
                            </div>
                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Fonte</Typography>
                            <div className="flex gap-4 my-2">
                                <div className='flex-1'>
                                    <FormControl sx={{ width: '100%' }}>
                                        <SelectMultiple
                                            filterKey='base_cp'
                                            label='Compra Pública'
                                            options={originPurchaseOptions.map(option => option.value)} 
                                            labels={originPurchaseOptions.map(option => option.label)}
                                            closeButton
                                            overprice
                                        />
                                    </FormControl>
                                </div>
                                <div className='flex-1'>
                                    <FormControl sx={{ width: '100%' }}>
                                        <SelectMultiple
                                            filterKey='base_rf'
                                            label='Referência'
                                            options={originReferenceOptions.map(option => option.value)} 
                                            closeButton
                                            overprice
                                            labels={originReferenceOptions.map(option => option.label)}
                                        />
                                    </FormControl>
                                </div>
                            </div>

                        </div>

                        <hr />
                    </CardContent>
                </div>
                <CardActions className='justify-end gap-2'>
                    <Button onClick={(ev) => { cleanFiltersOverprice(); onClose(); setSelectedGroup(""); setGroupType("") }} variant='text'>Resetar</Button>
                    <Button onClick={handleSend} variant='contained'>Aplicar</Button>
                </CardActions>
            </Card>
        </div>
    </Modal >);
}

export default AdvancedFilterOverprice;

